export default __webpack_public_path__ + "static/media/attachment.3deff8e6.png";